import { Button, Container, Flex, Heading } from '@chakra-ui/react'
import type { AxiosError } from 'axios'
import type { CreateFlexGroup, FlexGroup } from 'brokertslib/src/dtos'
import { useCustomToast } from 'BrokerTsLib/src/hooks/useCustomToast'
import { useCreate } from 'brokertslib/src/hooks/useFlexGroup'
import { useNavigate } from 'react-router-dom'

import { Section } from '@/components/Section'
import { FlexGroupForm } from '@/containers/flex-group/FlexGroupForm'
import { PageContent } from '@/containers/PageContent'
import { PageToolbar } from '@/containers/PageToolbar'
import { ArrowLeft } from '@/icons'

export const FlexGroupCreatePage = () => {
  const navigate = useNavigate()
  const { errorToast } = useCustomToast()

  const { mutateAsync: createAsync } = useCreate()

  const onSubmit = (data: CreateFlexGroup) =>
    createAsync(data)
      .then((response) => {
        navigate(`/flex-group/${response.id}`)
        return response
      })
      .catch(errorToast('Chyba při vytváření flexibilní skupiny')) as Promise<FlexGroup | AxiosError>

  return (
    <Section>
      <Container>
        <PageContent>
          <PageToolbar
            sx={{ w: '2xl', margin: '0 auto' }}
            leftElements={
              <Flex sx={{ gap: 4, alignItems: 'center' }}>
                <Heading as="h1">Nová flexibilní skupina</Heading>
              </Flex>
            }
            rightElements={
              <Flex sx={{ gap: 4 }}>
                <Button
                  variant="ghost"
                  onClick={() => navigate('/flex-group/list')}
                >
                  <ArrowLeft color="secondary.500" />
                  Zpět na přehled flexibilních skupin
                </Button>
              </Flex>
            }
          />

          <FlexGroupForm
            flexGroup={{ name: '', description: '' }}
            create
            onSubmit={onSubmit}
          />
        </PageContent>
      </Container>
    </Section>
  )
}
